import React from 'react';

const AuthContext = React.createContext({ authenticated: false });

export default AuthContext;
